import * as React from 'react';

const BookmarkFilled24 = ({ title, titleId, ...props }) => /* @__PURE__ */ React.createElement("svg", { fill: "none", viewBox: "0 0 24 24", width: 24, height: 24, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "currentColor",
    d: "M4 3.75A2.75 2.75 0 0 1 6.75 1h10.5A2.75 2.75 0 0 1 20 3.75v18.28a1.25 1.25 0 0 1-1.977 1.017l-5.878-4.02a.25.25 0 0 0-.29 0l-5.878 4.02A1.25 1.25 0 0 1 4 22.028z"
  }
));
BookmarkFilled24.Size = 24;
BookmarkFilled24.Title = "BookmarkFilled";

export { BookmarkFilled24 as default };
